import type { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  DesktopTitle,
  MobileTitle,
  PageTitleHeader,
} from './page-title.styled';

export const PageTitle = (): ReactElement => {
  return (
    <PageTitleHeader size="medium" noMargin>
      <DesktopTitle>
        <FormattedMessage id="UPSELL_MEMBERSHIPS_HEADLINE_DESKTOP" />
      </DesktopTitle>
      <MobileTitle>
        <FormattedMessage id="UPSELL_MEMBERSHIPS_HEADLINE_MOBILE" />
      </MobileTitle>
    </PageTitleHeader>
  );
};
